import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import CircleXIcon from '../icons/CircleXIcon';
import sizes from './sizes';
const DeclineButton = ({ disabled, onClick, title, id, className, size, dataTestId, }) => {
    return (React.createElement(CircleButton, { id: id, size: size, className: className, color: "red", disabled: disabled, onClick: onClick, title: title, dataTestId: dataTestId },
        React.createElement(CircleXIcon, null)));
};
DeclineButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string,
};
DeclineButton.defaultProps = {
    size: sizes.normal,
    disabled: false,
    title: '',
};
export default DeclineButton;
